// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e2057e9","952":"ffad947d","998":"ae385e8c"}[chunkId] + ".chunk.js";
};